<template><div><h1 id="korrespondenzarten" tabindex="-1"><a class="header-anchor" href="#korrespondenzarten"><span>Korrespondenzarten</span></a></h1>
<p>Korrespondenzarten — Definiert Korrespondenzarten</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit dem Einrichten der Korrespondenzarten kann der Systemverwalter die Benutzereingaben steuern. Jede Korrespondenzart kann verschiedene Prozesse innerhalb funtrade auslösen (Ereignisverknüpfungen) und im Output auf verschiedenartige Dokumentvorlagen verweisen. In dieser Tabelle werden die Vorgaben definiert und für den Benutzer abrufbar hinterlegt. Die Dateneingabe nimmt der Systemverwalter des Kunden vor. Er bestimmt also, welche Korrespondenzen von den Benutzern gewählt werden können.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Korrespondenzen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Korrespondenzart</dt>
<dd>Kürzel für die Korrespondenzart</dd>
<dt>Bezeichnung</dt>
<dd>Bezeichnung der Korrespondenzart</dd>
<dt>Korrespondenztyp</dt>
<dd>Korrespondenztyp. Der Korrespondenztyp definiert ein Export-Format. Wenn Document Output verwendet wird, spielt das keine Rolle.</dd>
<dt>Kanal</dt>
<dd>Zielkanal für die Korrespondenz (in der Regel Post oder E-Mail).</dd>
<dt>Dokumentcode</dt>
<dd>Briefcode, der im Outputformat mitgegeben wird, um die Dokumentvorlage zu bestimmen</dd>
<dt>Dokumentensatz</dt>
<dd>Dieser Dokumentensatz wird als Output erzeugt. Kann leer bleiben, wenn in eine Steuerdatei exportiert wird.</dd>
<dt>Aufbereitung</dt>
<dd>Aubereitung mit Batchjob oder sofort. Das ist nur ein Vorschlagswert und kann beim Erfassen einer Korrespondenz überschrieben werden.</dd>
<dt>Optionen für E-Rechnung</dt>
<dd>Optional können E-Rechnung zusätzlich zum normalen Output erzeugt werden.</dd>
<dt>I-Ereignis 1</dt>
<dd>Initialereignis 6-stellig, welches beim Verarbeitungslauf mit einem allfällig manuell eingegebenen Betrag und der Adresse verknüpft wird. Wird auch für die ESR-Produktion benötigt. Es kann angegeben werden, ob das Ereignis auch gerade verknüpft werden soll (beim Aufbereiten der Korrespondenz).</dd>
<dt>I-Ereignis 2</dt>
<dd>wie <span class="guilabel">I-Ereignis 1</span>, z.B. zur Produktion eines zweiten ESR</dd>
<dt>R-Ereign. RDI</dt>
<dd>hält die Reaktion des Kunden automatisch als Responseereignis im System fest</dd>
<dt>Label Text 1</dt>
<dd>Bezeichnung des Vorschlagwertes Text 1. Dieser erscheint im Fenster &quot;Korrespondenz&quot;</dd>
<dt>Vorschlagswert Text 1</dt>
<dd>Vorschlagswert Text 1</dd>
<dt>Label Text 2</dt>
<dd>Bezeichnung des Vorschlagwertes Text 2</dd>
<dt>Vorschlagswert Text 2</dt>
<dd>Vorschlagswert Text 2</dd>
<dt>Label Zahl 1</dt>
<dd>Bezeichnung des Vorschlagwertes Text 1</dd>
<dt>Vorschlagswert Zahl 1</dt>
<dd>Vorschlagswert Zahl 1</dd>
<dt>Label Zahl 2</dt>
<dd>Bezeichnung des Vorschlagwertes Text 2</dd>
<dt>Vorschlagswert Zahl 2</dt>
<dd>Vorschlagswert Zahl 2</dd>
<dt>Label Datum 1</dt>
<dd>Bezeichnung des Vorschlagwertes Text 1</dd>
<dt>Vorschlagswert Datum 1</dt>
<dd>Vorschlagswert Datum 1</dd>
<dt>editierbar</dt>
<dd>j = ja, der Benutzer kann die Werte editieren; n = nein, der Benutzer kann die Werte nicht editieren</dd>
<dt>E-Verknüpfung</dt>
<dd>ja, beim zuweisen der Korrespondenz wird das definierte Ereignis mit der Adresse verknüpft; nein, das Ereignis wird nicht verknüpft</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/customer/korrespondenz.html">Korrspondenz</RouteLink></p>
</div></template>


